import { ProcedureStep, ProcedureStepType } from '@/types/ProcedureStep';

type CaptureOptions = { version?: unknown; capture?: { sequence?: unknown; direct?: unknown } } | null;

/** The GraphQL Json scalar is serialized as a string; accept an already-parsed object as well. */
const parseOptions = (options: unknown): CaptureOptions => {
  if (typeof options !== 'string') return (options as CaptureOptions) ?? null;
  try {
    return JSON.parse(options);
  } catch {
    return null;
  }
};

/** V1 deliberately supports only the approved, standalone surgeon action. */
export const isDirectProcedureStep = (step: ProcedureStep): boolean => {
  if (step.type !== ProcedureStepType.SurgeonLeftOR) return false;
  const options = parseOptions(step.options);
  return options?.version === 1 && options.capture?.sequence === false && options.capture?.direct === true;
};

export const sequenceSteps = <T extends ProcedureStep>(steps: T[]): T[] =>
  steps.filter(step => !isDirectProcedureStep(step));
